@if (readRole()) {
  <section class="flex flex-col gap-4">
    <div
      class="flex gap-2 items-center w-full border-b border-gray-300 *:p-2.5 *:text-sm *:w-[12.5rem] *:border-gray-300"
    >
      @for (item of segmentOptions; track item.value) {
        <button
          [routerLink]="[item.path]"
          class="relative border border-b-0 rounded rounded-b-none rounded-bl-none rounded-br-none"
        >
          {{ item.label }}
          @if (segment() === item.value) {
            <div
              class="bg-white h-px w-full absolute -bottom-[1px] right-0"
            ></div>
          }
        </button>
      }
    </div>
    <router-outlet />
  </section>
} @else {
  <section class="flex flex-col gap-4">
    <div class="flex items-center justify-center w-full h-64">
      <p class="text-gray-500">접근 권한이 없습니다.</p>
    </div>
  </section>
}
